import React, { Component} from 'react';
import './App.css';
import { BrowserRouter as Router } from "react-router-dom";
import { Container,Row,Col} from 'react-bootstrap';

import configs from './Config.json';
//Components
import Header from './components/HeaderComponents/Header';
import ModalSwitch from './components/HeaderComponents/ModalSwitch';
import Footer from './components/FooterComponents/Footer';
import BottomNav from './components/FooterComponents/BottomNav';


class App extends Component{

  constructor (props){
    super(props);
      
    this.state = {
      //Esta variable solo funciona en local
      //es para el servidor
      varPais: window.location.pathname,
      countryID: '', 
      countryURL: '',
      fullEventos: [],
      fullEventosOriginal: []
    }

  }
  
  render(){
    var countryID = 0;
    var countryURL = '';
    if (this.state.varPais === configs[0].paisSV) {countryID = 1; countryURL = configs[0].simanSV;}
    if (this.state.varPais === configs[0].paisGT) {countryID = 2; countryURL = configs[0].simanGT;}
    if (this.state.varPais === configs[0].paisCR) {countryID = 5; countryURL = configs[0].simanCR;}
    if (this.state.varPais === configs[0].paisNI) {countryID = 4; countryURL = configs[0].simanNI;}
    return (
      <Router>
      <Container fluid className="clubes--row">
       
          <Header fullEventos={this.state.fullEventos} fullEventosOriginal={this.state.eventosOriginal} idPais={countryID} urlPais={countryURL} varPais={this.state.varPais}></Header>
          {/** Configuracion de rutas */}
          <Row className="clubes--row justify-content-center">
            <Col> 
                <ModalSwitch varPais={this.state.varPais} idPais={countryID} urlPais={countryURL} />
            </Col>
          </Row>
          
          <BottomNav idPais={countryID} urlPais={countryURL} varPais={this.state.varPais}></BottomNav>

      </Container>
      <Footer varPais={this.state.varPais}></Footer>
      </Router>
    )

  }
}

export default App;
